import styled from 'styled-components';

export const GeneralGlobalAlertBannerWrapper = styled.div`
    #banner {
        position: sticky;
        top: 0;
        width: 100%;
        z-index: 1;

        .ant-alert {
            border-radius: 0;
        }
    }
`;

export const CustomGlobalAlertBannerWrapper = styled.div`
    #custom-banner {
        position: absolute;
        top: 40px;
        right: 50px;
        z-index: 1002; // to override modals mask
    }
`;
